export const jenkinsfileSnippet = ({ appId, apiBaseUrl }) => `pipeline {
    agent { label 'YOUR-AGENT' }

    environment {
        BETA_APPSTORE_URL    = "${apiBaseUrl}"
        BETA_APPSTORE_APP_ID = "${appId}"
        BETA_APPSTORE_TOKEN  = credentials('beta-appstore-token')
    }

    stages {
        stage('Build') {
            steps {
                // Replace with your own build command, e.g.
                //   sh './gradlew assembleRelease'
                //   sh 'xcodebuild -scheme MyApp archive ...'
                sh 'YOUR_BUILD_COMMAND'
            }
        }

        stage('Upload to Beta Appstore') {
            steps {
                sh '''
                    curl -fS -X POST \\
                      "\${BETA_APPSTORE_URL}/app/\${BETA_APPSTORE_APP_ID}/upload/build" \\
                      -H "Authorization: Bearer \${BETA_APPSTORE_TOKEN}" \\
                      -F "os=Android" \\
                      -F "version=1.0.0" \\
                      -F "environment=Staging" \\
                      -F "is_public=false" \\
                      -F "notes=Build from Jenkins \${BUILD_NUMBER}" \\
                      -F "file=@path/to/your/build.apk"
                '''
            }
        }
    }
}`;

export const githubActionsSnippet = ({ appId, apiBaseUrl }) => `name: Upload to Beta Appstore

on:
  push:
    branches: [master]

jobs:
  upload:
    runs-on: ubuntu-latest
    steps:
      - uses: actions/checkout@v4

      # Replace with your own build steps, e.g.
      #   - run: ./gradlew assembleRelease
      #   - run: xcodebuild -scheme MyApp archive ...
      - name: Build
        run: echo "YOUR_BUILD_COMMAND"

      - name: Upload build artifact to Beta Appstore
        env:
          BETA_APPSTORE_URL:    ${apiBaseUrl}
          BETA_APPSTORE_APP_ID: ${appId}
          BETA_APPSTORE_TOKEN:  \${{ secrets.BETA_APPSTORE_TOKEN }}
        run: |
          curl -fS -X POST \\
            "$BETA_APPSTORE_URL/app/$BETA_APPSTORE_APP_ID/upload/build" \\
            -H "Authorization: Bearer $BETA_APPSTORE_TOKEN" \\
            -F "os=Android" \\
            -F "version=1.0.0" \\
            -F "environment=Staging" \\
            -F "is_public=false" \\
            -F "notes=Build from GitHub Actions \${{ github.run_number }}" \\
            -F "file=@path/to/your/build.apk"`;

export const curlSnippet = ({ appId, apiBaseUrl }) => `curl -fS -X POST \\
  "${apiBaseUrl}/app/${appId}/upload/build" \\
  -H "Authorization: Bearer $BETA_APPSTORE_TOKEN" \\
  -F "os=Android" \\
  -F "version=1.0.0" \\
  -F "environment=Staging" \\
  -F "is_public=false" \\
  -F "notes=Manual upload" \\
  -F "file=@path/to/your/build.apk"`;
